import { registerEphemeralRoute } from "./handle-ephemeral-routes";
import { sendPendingChatMessage } from "@/actions/sendPendingChatMessage";
import { EventContext } from "@/domains/metrics/context";

/**
 * Registers all ephemeral route handlers.
 * Should be called during module initialization, before React Router initializes.
 */
export const registerEphemeralRouteHandlers = (): void => {
  // Register /chat/new?message=... handler
  registerEphemeralRoute({
    path: "/chat/new",
    queryParam: "message",
    handler: async (message, { store, pageStore }) => {
      // Open side panel to chat
      store.sidePanel.goToMemIt();
      // Navigate to notes list
      store.navigation.goToNotes({ config: { replace: true } });
      // Send the pending message
      await sendPendingChatMessage({
        pageStore,
        message,
      });
    },
  });

  // Register /notes/new?title=... handler
  registerEphemeralRoute({
    path: "/notes/new",
    queryParam: "title",
    handler: async (title, { store }) => {
      await store.notes.composeNewNote({
        eventContext: EventContext.EphemeralRoute,
        title,
        autoFocusPosition: "end",
      });
    },
  });
};
